const TEXT_COLOR_MAP: Record<string, string> = {
  '#4380F5': '#FFFFFF',
  '#838732': '#FFFFFF',
  '#1C2E22': '#FFFFFF',
  '#F9D75B': '#636363',
  '#F29009': '#636363',
  '#F7BDB2': '#636363',
  '#E9E3E3': '#636363',
  '#FFFFFF': '#636363'
};

export function getTextColor(backgroundColor?: string): string {
  if (!backgroundColor) return '#636363';
  return TEXT_COLOR_MAP[backgroundColor.toUpperCase()] || '#636363';
}
